import { useRef, useState } from "react";
import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";
import { debounce } from "lodash-es";
import { useNavigate } from "react-router-dom";
import { GuidelineType } from "../type";
import dataJson from "@/../public/data.json";
import { publicPath } from "@/utils/base";

import "./index.less";

const protocol = document.location.protocol;
const domain = window.location.host;
const prefix = "guideline";

function Guideline() {
  const { design } = dataJson;
  const [swiperLeft, setSwiperLeft] = useState<number>(0);
  const swiperRef = useRef<any>();
  const moveNum = useRef<number>(0);

  const navigate = useNavigate();

  const moveSwiper = (direction: boolean) => {
    const i = (direction && moveNum.current >= 0) || (!direction && moveNum.current <= 3 - design.guideline_arr.length);
    if (i) {
      return;
    }
    moveNum.current = direction ? moveNum.current + 1 : moveNum.current - 1;
    const distance = 354 * moveNum.current;
    setSwiperLeft(distance);
  };
  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-title`}>{design.guideline_title}</div>
        <div className={`${prefix}-describe`}>{design.guideline_describe}</div>
        <div className={`${prefix}-swiper-wrap`}>
          <LeftCircleFilled
            className={`${prefix}-swiper-circleOutlined leftCircle ${moveNum.current >= 0 ? "displayNone" : ""}`}
            onClick={debounce(() => {
              moveSwiper(true);
            }, 300)}
          />
          <div className={`${prefix}-swiper`} ref={swiperRef} style={{ transform: `translateX(${swiperLeft}px)` }}>
            {design.guideline_arr.map((item: GuidelineType, index: number) => {
              return (
                <div
                  key={index}
                  className={`${prefix}-slide`}
                  style={{ background: `url(${item.url})`, backgroundSize: "100% 100%" }}
                  onClick={() => {
                    navigate(
                      `${publicPath}/iframe-document?url=${protocol}//${domain}/${item.link}&root=设计&title=通用设计基础`
                    );
                  }}
                >
                  <div className={`${prefix}-slide-title`}>{item.title}</div>
                  <div className={`${prefix}-slide-describe`}>{item.describe}</div>
                  <img src={design.slide_arrow_hover} className={`${prefix}-slide-circle hover_active`} alt="" />
                  <img src={design.slide_arrow} className={`${prefix}-slide-circle`} alt="" />
                </div>
              );
            })}
          </div>
          <RightCircleFilled
            className={`${prefix}-swiper-circleOutlined rightCircle ${
              moveNum.current <= 3 - design.guideline_arr.length ? "displayNone" : ""
            }`}
            onClick={debounce(() => {
              moveSwiper(false);
            }, 300)}
          />
        </div>
      </div>
    </div>
  );
}

export default Guideline;
